import { createFileRoute } from '@tanstack/react-router'
import { RepresentativeWizardPage } from '@/features/cases'

interface KybInformationSearch {
  /** Information-request token from the representative's emailed link. */
  token?: string
}

/**
 * `/kyb/information` — public, no-login Representative wizard (AMLIQ-410) opened
 * from the emailed link. The token in the query string resolves the KYB check
 * server-side (`GET /cases/checks/by-token/{token}`), so no account is needed.
 */
export const Route = createFileRoute('/kyb/information')({
  validateSearch: (search: Record<string, unknown>): KybInformationSearch => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: KybInformationRoute,
})

function KybInformationRoute() {
  const { token } = Route.useSearch()
  return <RepresentativeWizardPage token={token} />
}
